import React from "react";

export default function useDarkMode(settings) {
  const darkMode = settings.darkMode === true;
  React.useEffect(() => {
    document.body.classList.toggle("dark", darkMode);
  }, [darkMode]);
  return [darkMode, settings.saveDarkMode];
}
